import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

import { Switch } from '@account_module/components/onboarding/Switch';
import { useMegaphoneOnboardContext } from '@account_module/context/MegaphoneOnboardContext';
import { DuplicateShowType, MegaphoneShowType } from '@account_module/types/Onboarding';

const ShowDetails = tw.div`flex items-start gap-4 p-4 border-r border-solid border-muted4 max-w-[317px]`;
const ShowImage = tw.img`h-[35px] w-[35px] rounded`;
const ShowTitle = tw.h4`text-left text-base font-semibold leading-[140%]`;
const DuplicatesRowsContainer = tw.div`flex flex-col`;
const SwitchContainer = tw.div`grid grid-cols-[auto_auto_auto] items-center gap-2 p-4`;
const SwitchLabel = tw.span`text-base text-muted font-semibold`;
const DuplicateId = tw.div`transition-all duration-100 font-normal text-base px-4 py-3`;

const OuterRow = tw.div`w-full grid grid-cols-[317px_1fr] bg-white even:bg-secondary border-b border-solid border-muted4`;
const InnerRow = tw.div`w-full grid grid-cols-[250px_250px_1fr] border-b not-first:border-b-0 border-solid border-muted4`;

export const DuplicateShow = ({ show }: { show: DuplicateShowType }) => {
  const { t } = useTranslation();
  const { showsToInclude, showsToExclude, setShowsToExclude, setShowsToInclude } =
    useMegaphoneOnboardContext();

  const handleIncludeShow = (id: string) => {
    setShowsToInclude([...showsToInclude, id]);
    showsToExclude.includes(id) && setShowsToExclude(showsToExclude.filter((_id) => _id !== id));
  };

  const handleExcludeShow = (id: string) => {
    setShowsToExclude([...showsToExclude, id]);
    showsToInclude.includes(id) && setShowsToInclude(showsToInclude.filter((_id) => _id !== id));
  };

  const toggleIncludeExclude = (val: boolean, id: string) =>
    val ? handleIncludeShow(id) : handleExcludeShow(id);

  return (
    <OuterRow>
      <ShowDetails>
        <ShowImage src={show.imageFile} alt={`${show.title} artwork`} />
        <ShowTitle>{show.title}</ShowTitle>
      </ShowDetails>
      <DuplicatesRowsContainer>
        {show.duplicates.map((duplicate: MegaphoneShowType) => (
          <InnerRow key={duplicate.id}>
            <DuplicateId css={[showsToExclude.includes(duplicate.id) && tw`opacity-40`]}>
              {duplicate.id}
            </DuplicateId>
            <DuplicateId css={[showsToExclude.includes(duplicate.id) && tw`opacity-40`]}>
              {duplicate.networkId}
            </DuplicateId>
            <SwitchContainer>
              <SwitchLabel>
                {t('account_module.onboard_page.duplicate_shows_list.action.exclude')}
              </SwitchLabel>
              <Switch
                onChange={(val) => toggleIncludeExclude(val as boolean, duplicate.id)}
                checked={showsToInclude.includes(duplicate.id as string)}
              />
              <SwitchLabel>
                {t('account_module.onboard_page.duplicate_shows_list.action.include')}
              </SwitchLabel>
            </SwitchContainer>
          </InnerRow>
        ))}
      </DuplicatesRowsContainer>
    </OuterRow>
  );
};
